import Component from 'vue-class-component';
import OrderElementAbstract from '../OrderAbstract/OrderElementAbstract';

@Component({
})
export default class OrderTableElement extends OrderElementAbstract {
}